<template>
  <div id="app" :style="{
      '--accentColor': accentColor,
      '--accentColorDark': accentColorDarken(-10),
      '--accentColorExtraDark': accentColorDarken(-25),
      '--accentColorRgb': accentColorRgb
    }">
    <div v-if="isCheckingLogin">
    </div>
    <div v-else>
      <Header v-if="shouldShowFrame"/>
      <div class="container scafolding">
        <div class="row justify-content-between">
          <div class="col-lg-3 sidebar" v-if="shouldShowFrame">
            <Sidebar />
          </div>
          <div :class="[{'col-lg-9 main': shouldShowFrame, 'col': !shouldShowFrame}]">
            <transition name="pageTransition" mode="out-in">
              <router-view/>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { mapState } from 'vuex';
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";

export default {
  name: "App",
  data: function () {
    return {
      shouldShowFrame: false,
      accentColor: '#FF5A5F',
    };
  },
  computed: {
    accentColorRgb: function () {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.accentColor);
      return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
    },
    ...mapState('session', ['isLoggedIn', 'isCheckingLogin', 'isLoggingOut', 'property']),
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newVal) {
        if (newVal === false && this.$router.currentRoute.path != '/login') {
          if (!this.isLoggingOut) {
            window.localStorage.setItem('oldPath', this.$router.currentRoute.path);
          }
          console.log('REDIRECTING TO LOGIN');
          this.$router.push('/');
        }
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.path == '/properties' || to.path == '/login' || to.path == '/') {
          if (from && from.path != '/dashboard') {
            window.setTimeout(() => {
              this.shouldShowFrame = false;
            }, 500);
          }
          else {
            this.shouldShowFrame = false;
          }

          if (from && from.path != '/login' && from.path != '/') {
            this.$store.dispatch('session/setPrevPath', from.path);
          }
        }
        else {
         this.shouldShowFrame = true; 
        }
      },
    },
    property: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          newVal = {
            color: 'FF5A5F',
          };
        }
        this.accentColor = `#${newVal.color}`;
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('session/checkLogin');
    // axios.get('/api/users/session/admin/read')
    //   .then((response) => {
    //     this.isCheckingLogin = false;
    //     this.isLoggedIn = response.data.loggedIn;
    //     if (!response.data.loggedIn) {
    //       this.$router.push('/login');
    //     }
    //   })
  },
  methods: {
    accentColorDarken: function (amount) {
      let color = this.accentColor;
      return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
    },
  },
  components: {
    Header,
    Sidebar,
  }
}
</script>

<style lang="scss">
// add some bootstrap stuff (only what we need)
@import "./styles/bootstrap/bootstrap-reboot";
@import "./styles/bootstrap/bootstrap-grid";
@import "./styles/bootstrap/_utilities";
@import "./styles/bootstrap/_buttons";
@import "./styles/bootstrap/_forms";
@import "./styles/bootstrap/_spinners";

@import "./styles/variables";

@font-face {
  font-family: "Helvetica Neue";
  font-weight: 400;
  font-style: normal;
  src: url('./assets/fonts/HelveticaNeue.woff') format('woff');
}

@font-face {
  font-family: "Helvetica Neue";
  font-weight: 500;
  font-style: normal;
  src: url('./assets/fonts/HelveticaNeue-Medium.woff') format('woff');
}

@font-face {
  font-family: "Baskerville";
  font-weight: 400;
  font-style: normal;
  src: url('./assets/fonts/Baskerville.woff') format('woff');
}
@font-face {
  font-family: "Montserrat-Regular";
  font-weight: 400;
  font-style: normal;
  src: url('./assets/fonts/(Montserrat-Regular)Montserrat-Regular.ttf') format('truetype');
}
@font-face {
  font-family: "Montserrat-SemiBold";
  font-weight: 500;
  font-style: normal;
  src: url('./assets/fonts/(Montserrat-SemiBold)Montserrat-SemiBold.ttf') format('truetype');
}
@font-face {
  font-family: "Montserrat-Bold";
  font-weight: 600;
  font-style: normal;
  src: url('./assets/fonts/(Montserrat-Bold)Montserrat-Bold.ttf') format('truetype');
}
@font-face {
  font-family: "Inter-Regular";
  font-weight: 400;
  font-style: normal;
  src: url('./assets/fonts/(Inter-Regular)Inter-Regular.ttf') format('truetype');
}
@font-face {
  font-family: "Inter-Medium";
  font-weight: 500;
  font-style: normal;
  src: url('./assets/fonts/(Inter-Medium)Inter-Medium.ttf') format('truetype');
}
@font-face {
  font-family: "Inter-SemiBold";
  font-weight: 600;
  font-style: normal;
  src: url('./assets/fonts/(Inter-SemiBold)Inter-SemiBold.ttf') format('truetype');
}
@font-face {
  font-family: "WorkSans-Medium";
  font-weight: 500;
  font-style: normal;
  src: url('./assets/fonts/(WorkSans-Medium)WorkSans-Medium.ttf') format('truetype');
}
.scafolding {
  margin-left: 0px!important;
  max-width: 100vw!important;
}
.btn {
  border-radius: 0;

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(var(--accentColorRgb), 0.25);
  }

  &.btn-red {
    background: var(--accentColor);
    border-color: var(--accentColor);
    color: white;

    &:hover {
      background: var(--accentColorDark);
      border-color: var(--accentColorDark);
    }
  }

  &.btn-red-outline {
    background: transparent;
    color: var(--accentColor);
    border-color: var(--accentColor);

    &:hover {
      background: var(--accentColor);
      color: white;
    }
  }
}

label,
label.col-form-label {
  font-size: 1rem;
  line-height: 1.142;
  color: #4A4A4A;

  &.col-form-label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.form-control {
  font-size: 1rem;
  line-height: 1.142;
  border: 1px solid #F4F4F3;
  border-radius: 0;
  height: calc(2.5em + 1rem + 2px);
  padding: 0.75rem 0.75rem;
  color: #4A4A4A;
  background: #F4F4F3;

  &:placeholder {
    color: #4A4A4A;
  }

  &:focus,
  &:active {
    box-shadow: 0 0 0 0.2rem rgba(var(--accentColorRgb), 0.25);
    border-color: var(--accentColor);
  }
}

div.form-group.error {
  margin-top: 1.5em;

  p {
    color: $red;
    font-weight: 500;
    margin: 0;
    font-size: 0.875rem;
  }
}

div.alert {
  padding: 22px 0;
  text-align: center;
  font-size: 0.875rem;
  color: #4A4A4A;
  background-color: rgba(var(--accentColorRgb), 0.05);
  margin: 50px 0;
  width: 100%;
}

div.container {
  @media all and (min-width: 1200px) {
    max-width: 1180px;
  }

  @media all and (min-width: 1400px) {
    max-width: 1300px;
  }
}

div.tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(#222222, 0.14);
  margin: 1em 0 2em;

  ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 0 10px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      button {
        display: block;
        padding: 24px 0 22px;
        font-size: 0.875rem;
        line-height: 1.142;
        color: #848484;
        border-bottom: 2px solid white;

        &:focus {
          box-shadow: none;
        }

        &:hover,
        &.active {
          color: #4A4A4A;
        }

        &.active {
          border-bottom: 2px solid var(--accentColor);
        }

        span.count {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: var(--accentColor);
          color: white;
          font-size: 0.7rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          margin-left: 0.5rem;
        }
      }
    }
  }
}

label.check {
  margin-top: 0.75em;
  margin-bottom: 0.75em;

  input[type="checkbox"] {
    display: none;

    &:checked + span {
      background-color: var(--accentColor);

      &:after {
        left: calc(100% - 17px);
      }
    }
  }

  span {
    display: block;
    width: 33px;
    height: 20px;
    background-color: darken(#F4F4F3, 10%);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background-color 250ms;

    &:after {
      content: "";
      position: absolute;
      display: block;
      top: 3px;
      left: 3px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: white;
      transition: left 250ms;
    }
  }
}

div.initials {
  background-color: var(--accentColor);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin: 0 13px 0 0;

  span {
    font-weight: 500;
    font-size: 0.8rem;
    line-height: 1;
    color: white;
  }
}

#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  font-size: 16px;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 100vh;

    > div,
    > header {
      width: 100%;
    }

    > div.container {
      flex-grow: 1;
      display: flex;

      > div.row {
        width: 100%;
      }
    }
  }
}

div.sidebar {
  position: relative;
  flex: 0 0 24%;
  max-width: 24%;

  &:after {
    content: "";
    width: 1px;
    background: #E9E9E9;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15px;
  }
}

div.main {
  flex: 0 0 72%;
  max-width: 72%;
}

// page transition, fade out and slide down
.pageTransition-enter-active, .pageTransition-leave-active {
  transition: opacity 500ms, transform 500ms;
}
.pageTransition-enter, .pageTransition-leave-to {
  opacity: 0;
  transform: translateY(100px) !important;
}
</style>
